import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
// import { YearChoser } from 'src/pages/ResidentProfilePage/Bills/YearChoser';
import { useStore } from 'src/stores';
import Statament from 'src/pages/ResidentProfilePage/Bills/Statament';
// import { monthNames } from 'src/utils/date';
import useStyles from './styles';
export const Bills = observer(props => {
  const store = useStore();
  const classes = useStyles();
  const accountId = props.accountId,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    setTriggerRefresh = props.setTriggerRefresh,
    userProfileData = props.userProfileData;
  const accountStatementsPreview = store.statement.accountStatementsPreview;
  let years = accountStatementsPreview.map(i => i.year);
  years = [...new Set(years)];
  const getStatemensByYear = year => accountStatementsPreview.filter(i => i.year === year);
  const statementsByYear = years.reduce((acc, year) => {
    let months = {};
    getStatemensByYear(year).map(i => ({
      month: i.month + 'm',
      statementId: i.statementId
    })).forEach(element => {
      if (!months[element.month]) {
        months = _objectSpread(_objectSpread({}, months), {}, {
          [element.month]: [element.statementId]
        });
      } else {
        months[element.month].push(element.statementId);
      }
    });
    acc[year] = {
      months: [...new Set(getStatemensByYear(year).map(i => i.month + 'm'))] || [],
      statements: getStatemensByYear(year) || [],
      statementsByMonth: months || {}
    };
    return acc;
  }, {});
  const getAccountStatementsPreview = async () => {
    const resp = await store.statement.getAccountStatementsPreviewAsync.run({
      accountId
    });
    return resp;
  };
  useEffect(() => {
    getAccountStatementsPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.billContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.choser
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.yearBlock
  }, years.map(year => {
    var _statementsByYear$yea;
    return /*#__PURE__*/React.createElement("div", {
      key: year
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.yearTitle,
      variant: "h4"
    }, year), (_statementsByYear$yea = statementsByYear[year]) === null || _statementsByYear$yea === void 0 ? void 0 : _statementsByYear$yea.months.map(i => {
      var _statementsByYear$yea2, _statementsByYear$yea3;
      const statementId = (_statementsByYear$yea2 = statementsByYear[year]) === null || _statementsByYear$yea2 === void 0 ? void 0 : _statementsByYear$yea2.statementsByMonth[i][0];
      const additionalStataments = [...((_statementsByYear$yea3 = statementsByYear[year]) === null || _statementsByYear$yea3 === void 0 ? void 0 : _statementsByYear$yea3.statementsByMonth[i])];
      additionalStataments.shift();
      return /*#__PURE__*/React.createElement(Statament, {
        additionalStataments: additionalStataments,
        key: statementId,
        propertyId: propertyId,
        residencyId: residencyId,
        setTriggerRefresh: setTriggerRefresh,
        statementId: statementId,
        userProfileData: userProfileData
      });
    }));
  })));
});